import React, { useState } from 'react';

const OpenInNewIcon = ({
  width = 14,
  height = 14,
  stroke = '#69727C',
  hoverStroke = '#F5F5F5',
  strokeWidth = 1,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M11.7197 6.13889C11.5717 6.13889 11.4297 6.19769 11.3251 6.30235C11.2204 6.40701 11.1616 6.54896 11.1616 6.69697V10.6035C11.1616 10.9119 10.9119 11.1616 10.6035 11.1616H1.67424C1.3659 11.1616 1.11616 10.9119 1.11616 10.6035V1.67424C1.11616 1.3659 1.3659 1.11616 1.67424 1.11616H5.58081C5.72882 1.11616 5.87077 1.05736 5.97543 0.952704C6.08009 0.848043 6.13889 0.706093 6.13889 0.558081C6.13889 0.410069 6.08009 0.268119 5.97543 0.163458C5.87077 0.0587976 5.72882 0 5.58081 0H1.67424C0.749642 0 0 0.749642 0 1.67424V10.6035C0 11.5281 0.749642 12.2778 1.67424 12.2778H10.6035C11.5281 12.2778 12.2778 11.5281 12.2778 10.6035V6.69697C12.2778 6.54896 12.219 6.40701 12.1143 6.30235C12.0097 6.19769 11.8677 6.13889 11.7197 6.13889ZM12.2778 0.558081V3.90657C12.2778 4.05458 12.219 4.19653 12.1143 4.30119C12.0097 4.40585 11.8677 4.46465 11.7197 4.46465C11.5717 4.46465 11.4297 4.40585 11.3251 4.30119C11.2204 4.19653 11.1616 4.05458 11.1616 3.90657V1.90529L6.5894 6.47736C6.48399 6.57824 6.34327 6.63382 6.19739 6.63222C6.0515 6.63061 5.91204 6.57193 5.80888 6.46876C5.70573 6.36558 5.64708 6.22611 5.64549 6.08022C5.64391 5.93434 5.69952 5.79363 5.80041 5.68824L10.3724 1.11616H8.37121C8.2232 1.11616 8.08125 1.05736 7.97659 0.952704C7.87193 0.848043 7.81313 0.706093 7.81313 0.558081C7.81313 0.410069 7.87193 0.268119 7.97659 0.163458C8.08125 0.0587976 8.2232 0 8.37121 0H11.7197C11.8677 0 12.0097 0.0587976 12.1143 0.163458C12.219 0.268119 12.2778 0.410069 12.2778 0.558081Z"
        stroke={isHovered ? hoverStroke : stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpenInNewIcon;
